<template>
  <v-app>
    <OverlayLoading :overlay="globalLoading"></OverlayLoading>

    <section v-if="navigation"
        class="navbar-section">
      <main-menu :context="navigation"></main-menu>
    </section>

    <v-main>
      <router-view
          :key="$route.fullPath"
          v-if="defaultGlobals"
          ref="applicationBodyWrapper"
          @rerenderMenu="rerenderMenu"
          @triggerOverlayLoading="handleShowLoading"
          :defaultGlobals="defaultGlobals"
          @headerSuppressed="headerSuppressed"
      />
    </v-main>

  </v-app>
</template>

<script>

import globalMixins from "@/mixins/globalMixins";
import MainMenu from "@/components/MainMenu";
import OverlayLoading from "@/components/OverlayLoading";

export default {
  name: 'App',
  mixins: [globalMixins],
  components: {
    MainMenu,
    OverlayLoading
  },

  data() {
    return {
      specialMenuCss: false,
      defaultGlobals: null,
      navigation: null
    }
  },

  async created() {

    if (this.$cookies.get('xKey') && this.$cookies.get('xKey') !== '') {
      this.$store.dispatch('key/setKey', this.$cookies.get('xKey'));
    }

    if (!this.$store.getters['key/getKey'] && process.env.VUE_APP_M360_KEY) {
      this.$store.dispatch('key/setKey', process.env.VUE_APP_M360_KEY);
    }

    await this.getNavigation();
  },

  methods: {

    async rerenderMenu(updatedMenu) {
      if (updatedMenu) {
        this.navigation = updatedMenu;
        await this.checkFixProperties(this.navigation);
        this.$forceUpdate();
      }
    },

    async getNavigation() {
      this.navigation = null;
      this.defaultGlobals = null;

      const requestOptions = {
        url: '/abcbridgeapi/',
        method: 'post',
        body: {
          layout: true
        }
      };

      return this.getSendData(requestOptions)
          .then(response => {
            this.navigation = response.menu;

            this.defaultGlobals = {
              chromeThemeColor: response.chromeThemeColor,
              description: response.description,
              favicon: response.favicon,
              footer: response.footer,
              header: (response.global) ? response.global.header : null,
              global: response.global,
              msTilePicker: response.msTilePicker,
              pageImage: response.pageImage,
              searchEngineCrawl: response.searchEngineCrawl,
              searchEngineVisible: response.searchEngineVisible,
              title: response.title
            };

            this.$forceUpdate();
          })
          .catch(error => {
            if (error && error.errors && error.errors[132] && error.errors[132].message) {
              this.clearMessages();
              this.licenseError();
            } else console.error(error);
          });
    },

    handleShowLoading: function (loadingValue) {
      this.globalLoading = loadingValue;
      this.$forceUpdate();
    },

    headerSuppressed: function () {
      this.specialMenuCss = true;
    }
  }
};
</script>

<style>
section.navbar-section {
  position: initial;
  display: contents;
}
</style>